import { prop } from 'ramda';
import { useDeviceSelector } from 'js/store/hooks';
import React, { memo } from 'react';
import { useComponentConfig } from 'js/hooks/component';

import { useGetFilterOptions } from './hooks';
import { IGamesGridConfig } from '../../types';
import { useDynamicReducerSelector } from '../../store';
import { MobileGamesFilters } from './components/MobileGamesFilters';
import { DesktopGamesFilters } from './components/DesktopGamesFilters';

import style from './GamesFilters.scss';

export const GamesFiltersBare: React.FC = () => {
    const {
        isSortingEnabled,
        isLabelFilterEnabled,
        isProviderFilterEnabled,
        isCategoryFilterEnabled
    } = useComponentConfig<IGamesGridConfig>();
    const isMobile = useDeviceSelector(prop('isMobile'));
    const isLoading = useDynamicReducerSelector(prop('isLoading'));
    const filters = useGetFilterOptions();
    const isFiltersEnabled =
        isSortingEnabled ||
        isLabelFilterEnabled ||
        isProviderFilterEnabled ||
        isCategoryFilterEnabled ||
        Boolean(filters.customFieldsOptions?.length);
    const isFiltersAvailable =
        Boolean(filters.labelOptions.length) ||
        Boolean(filters.providerOptions.length) ||
        Boolean(filters.categoryOptions.length) ||
        Boolean(filters.customFieldsOptions?.length);

    if (isLoading || !(isFiltersEnabled && isFiltersAvailable)) {
        return null;
    }

    return (
        <div className={`${style.container} cms-games-grid-filters`}>
            {!isMobile && <DesktopGamesFilters />}
            {isMobile && <MobileGamesFilters />}
        </div>
    );
};

export const GamesFilters = memo(GamesFiltersBare);
